'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_config$LoginConfig(testCookieEvery) {
  this.Dt = 0;
  this.Dt = testCookieEvery;
}
export { $c_Lpresto_config$LoginConfig as $c_Lpresto_config$LoginConfig };
$p = $c_Lpresto_config$LoginConfig.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_config$LoginConfig;
/** @constructor */
function $h_Lpresto_config$LoginConfig() {
}
export { $h_Lpresto_config$LoginConfig as $h_Lpresto_config$LoginConfig };
$h_Lpresto_config$LoginConfig.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("LoginConfig"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, this.Dt);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 1);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_config$LoginConfig) && (this.Dt === x$0.Dt)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "LoginConfig";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Dt;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_config$LoginConfig(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j6)));
}
export { $isArrayOf_Lpresto_config$LoginConfig as $isArrayOf_Lpresto_config$LoginConfig };
var $d_Lpresto_config$LoginConfig = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_config$LoginConfig, "presto.config$LoginConfig", ({
  j6: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_config$LoginConfig as $d_Lpresto_config$LoginConfig };
//# sourceMappingURL=presto.config$-Login-Config.js.map
